module.exports = __webpack_public_path__ + "static/img/A1.ef974ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/A1.png
// module id = DtA1
// module chunks = 0